import { render, staticRenderFns } from "./OrdenDeServicioLiquidarModal.vue?vue&type=template&id=4247c7f1"
import script from "./OrdenDeServicioLiquidarModal.vue?vue&type=script&lang=js"
export * from "./OrdenDeServicioLiquidarModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports